import { nanoid } from 'nanoid';
import fetch from 'node-fetch';
import { Behavior } from '../../types/distribution';
import { ComponentError, JoiErrorResponse } from '../../types/misc';
import emptyStringToUndefined from '../emptyStringToUndefined';

interface PutBehaviorResponse {
    success: boolean,
    behavior?: Behavior,
    errors: ComponentError[]
}

const putBehavior = async (token: string, distributionName: string, originId: string, behavior: Behavior): Promise<PutBehaviorResponse> => {
    const response = await fetch(`${process.env.REACT_APP_ADN_MANAGEMENT_BASE_URL}/v1/distributions/${distributionName}/origins/${originId}/behaviors/${behavior.id}`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(emptyStringToUndefined(behavior))
    });

    if (response.status === 400) {
        const error = (await response.json());

        // not a joi error
        if (!error.validation) {
            return {
                success: false,
                errors: [{
                    message: error.message,
                    path: '',
                    uiId: nanoid()
                }]
            };
        }

        const joiError = error as JoiErrorResponse;
        return {
            success: false,
            errors: joiError.validation.errors
        };
    }

    if (!response.ok) {
        throw new Error(`Unexpected error when updating a behavior. Got status code ${response.status}`);
    }

    return {
        success: true,
        behavior: await response.json(),
        errors: []
    };
};

export default putBehavior;
